import { ApiResult } from '@models/api';
import { useMutation, UseMutationOptions } from '@hooks/react-query';
import { fetcherMutation } from '@utils/react-query';

import { MVP_API_BASE_URL } from 'constants/new-configs';
import { ActionLogParams } from '../models';
import COOKIES_KEY from 'constants/cookies';
import Cookies from 'js-cookie';

function useRSubmitActionLog(
  options: UseMutationOptions<
    ApiResult<{ message: string }>,
    Record<string, unknown>,
    ActionLogParams
  > = {},
) {
  return useMutation<
    ApiResult<{ message: string }>,
    Record<string, unknown>,
    ActionLogParams
  >({
    mutationFn: async ({ context, variables }) =>
      await fetcherMutation({
        context: {
          ...context,
          meta: {
            ...context?.meta,
            basePath: '/api',
            baseUrl: MVP_API_BASE_URL,
            token: Cookies.get(COOKIES_KEY.JWT_TOKEN),
            keepalive: true, // Add keepalive option
          },
          method: 'POST',
          path: 'user_action_logs/v1/web-logs',
        },
        variables,
      }),
    ...options,
  });
}

export default useRSubmitActionLog;
